import { createFileRoute } from "@tanstack/react-router";
import { BusinessStep } from "@/features/onboarding/steps/business-step";
import { clearBusinessId } from "@/features/onboarding/use-business-id";
import { requireAuth } from "@/lib/auth-guard";

export const Route = createFileRoute("/onboarding/new")({
  beforeLoad: async (args) => {
    await requireAuth(args);
    clearBusinessId();
  },
  component: BusinessStep,
});
